import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import * as actions from '../store/actions/auth.actions';
import * as selectors from '../store/reducers';
import { ENGINE_METHOD_DIGESTS } from 'constants';

@Component({
  selector: 'sd-reset',
  templateUrl: 'reset.component.html',
  styleUrls: ['reset.component.scss']
})
export class ResetComponent implements OnInit {
  loading$: Observable<boolean>;
  constructor(public store: Store<any>) {}

  ngOnInit() {
    this.loading$ = this.store.select(selectors.auth.getLoading);
  }

  reset(payload: any) {
    this.store.dispatch(new actions.RequestAuthForgotPasswordAction(payload));
  }
}
